
import React from 'react';
import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';
import isNil from 'lodash/isNil';

const COMBOBOX_LABEL_STYLES = {
    label: {
        //color: theme.fabricTheme.palette.neutralTertiary
   }
};

const FilterItemValues = (props) => {

    const handleChange = (e, item) => {
        if (props.onChange) {
            props.onChange(props.definition.id, item.key);
        }
    }

    const getOptions = () => {
        let options = [];

        options.push({
            key: '',
            text: '<<vše>>'
        });

        options = [
            ...options,
            ...props.definition.values.map(item => {
                return {
                    key: item[0],
                    text: item[1]
                }
            })
        ];
        return options;
    }

    const getValue = () => {
        let value = props.value;
        if (isNil(value)) {
            value = '';
        }
        return value;
    }

    return (
        <ComboBox
            label={props.definition.title}
            options={getOptions()}
            selectedKey={getValue()}
            onChange={handleChange}
            styles={COMBOBOX_LABEL_STYLES}
        />
    );
}

export default FilterItemValues;
